module.exports = __webpack_public_path__ + "assets/img/18_932.f00f121f.jpg";